<mat-form-field>
  <mat-label>Version to apply</mat-label>
  <input (ngModelChange)="version.set($event)" [ngModel]="version()" matInput>
</mat-form-field>
<ui-button (clicked)="applyUpdate(version())" buttonStyle="filled">
  apply version
</ui-button>

<ui-button (clicked)="reloadView()" buttonStyle="filled">
  reload view
</ui-button>

<ui-button (clicked)="testUrlRestorationOnLiveUpdateReload('/cart')" buttonStyle="filled">
  Reload view to cart
</ui-button>

<ui-button (clicked)="testUrlRestorationOnLiveUpdateReload('/checkout')" buttonStyle="filled">
  Reload view to checkout
</ui-button>

<ui-button (clicked)="testUrlRestorationOnLiveUpdateReload('/search?q=cola&sort=name_asc')" buttonStyle="filled">
  Reload view to search
</ui-button>

<ui-button (clicked)="testUrlRestorationOnLiveUpdateReload('/scanner/CART_SCANNER/')" buttonStyle="filled">
  Reload view to scanner
</ui-button>

<ui-button (clicked)="removeAllButCurrentBundle()" buttonStyle="filled">
  removeAllButCurrentBundle
</ui-button>

<strong>CurrentVersion: {{ currentVersion() }}</strong>

<pre>
  {{ error() | json }}
</pre>

@for (bundle of availableBundles(); track bundle) {
  <ui-button (clicked)="applyUpdate(bundle)" buttonStyle="filled">
    apply {{ bundle }}
  </ui-button>
}

<strong>Native update debugger</strong>
<ui-button buttonStyle="filled" (clicked)="openNativeUpdateDialog()">Open Dialog</ui-button>

<strong>semver check debugger</strong>
<mat-form-field>
  <mat-label>V1</mat-label>
  <input (ngModelChange)="v1.set($event)" [ngModel]="v1()" matInput>
</mat-form-field>

<mat-form-field>
  <mat-label>V2</mat-label>
  <input (ngModelChange)="v2.set($event)" [ngModel]="v2()" matInput>
</mat-form-field>

<ui-button (clicked)="testSemver()" buttonStyle="filled">
  test
</ui-button>

V1 is newer than v2 : {{ isNewer() }}
